module.exports = __webpack_public_path__ + "static/media/imgTarget.5106d72d.svg";